import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import Input from "../layout/input/Input";
import Preload from '../layout/preload/Preload';
import Form from "../layout/form/Form";
import InputPhone from '../layout/input/InputPhone';
import Alerta from '../layout/alert/Alerta';
import InputCep from '../layout/input/InputCep';
import InputPassword from '../layout/input/InputPassword';
import InputSelectLogradouro from '../layout/input/InputSelectLogradouro';
import InputSelectUF from '../layout/input/InputSelectUF';

import ClienteService from '../../service/ClienteService';

class Cadastro extends  AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            erro: '',                                 

            preload: false,                            
            
            erroForm: {   
                cnpj: '',                             
                razao: '',
                fantasia: '',
                telefone: '',
                inscr: '',
                cep: '',
                logradouro: '',
                endereco: '',
                numero: '',                
                bairro: '',
                cidade: '',
                uf: '',                
                usuario: '',
                email: '',
                senha: ''                
            },            

            passo: 1,            
        
            form: {
                id: 0,                                   
                razao: '',
                fantasia: '',
                telefone: '',
                inscr: '',
                cep: '',
                logradouro: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf:'',                                
                usuario: '',
                email: '',
                senha: ''                
            },            

            //form: {
                // id: 0,            
                // cnpj: '10276888000143',
                // razao: 'Avance Sistemas e Consultoria LTDA',
                // fantasia: 'Avance Sistemas',
                // telefone: '(35) 3697-0900',
                // inscr: '0010855930012',
                // cep: '37701024',
                // logradouro: 'RUA',
                // endereco: 'Piaui',
                // numero: '178',
                // complemento: '',
                // bairro: 'Centro',
                // cidade: 'Poços de Caldas',
                // uf:'MG',                                                    
                // usuario: 'Eliel',
                // email: 'batistondeoliveira2@yahoo.com.br',
                // senha: '123456'                
            //},            

            logradouros: [],            

            preview: false,            
            
            btnFinalizar: 'FINALIZAR'
        }               
    }    

    onChange(e) {  
        const form = this.state.form;                 
        form[e.target.name] = e.target.value;        
        this.setState({form: form});
    }    

    onLoad(lista) {        
        this.setState({logradouros: lista});        
    }       

    onBlurCep(endereco) {                
        const form = this.state.form;                                
        const erro = this.state.erroForm;            

        form.logradouro = endereco['logradouro'];        
        form.endereco = endereco['endereco'];        
        form.bairro = endereco['bairro'];
        form.cidade = endereco['cidade'];
        form.uf = endereco['uf'];
                
        erro.cep = '';
        
        this.setState({
            form: form,
            erroForm: erro
        });        
    }

    onErroCep(msgErro) {                
        const erro = this.state.erroForm;

        erro.cep = msgErro;

        this.setState({erroForm: erro});
    }

    limpaVariavelErro() {
        let erro = this.state.erroForm;

        erro.cnpj = '';
        erro.razao = '';
        erro.fantasia = '';
        erro.inscr = '';                
        erro.telefone = '';
        erro.cep = '';
        erro.logradouro = '';                
        erro.endereco = '';
        erro.numero = '';        
        erro.bairro = '';
        erro.cidade = '';
        erro.uf = '';        
        erro.usuario = '';
        erro.email = '';
        erro.senha = '';        

        this.setState({ erroForm: erro });
    }

    validaStep1() {        
        this.limpaVariavelErro();
        
        let form = this.state.form;        
        let erro = this.state.erroForm;        
        let exibeErro = false;        
        
        form.cnpj = this.props.cnpj;

        if(!form.cnpj) {
            erro.cnpj = "Informe o campo Cnpj";
            exibeErro = true;
        } 

        if(!form.razao) {
            erro.razao = "Informe o campo Razão Social";
            exibeErro = true;
        }    
        
        if(!form.fantasia) {
            erro.fantasia = "Informe o campo Fantasia";
            exibeErro = true;
        }  

        if(!form.inscr) {
            erro.inscr = "Informe o campo Inscrição Estadual";
            exibeErro = true;
        }
        
        if(!form.telefone) {            
            erro.telefone = "Informe o campo Telefone";
            exibeErro = true;
        }        

        if(exibeErro) {
            this.setState({ erroForm: erro });

            return;
        }        

        this.setState({passo: 2});          
    }

    validaStep2() {        
        this.limpaVariavelErro();        

        let form = this.state.form; 
        let erro = this.state.erroForm;               
        let exibeErro = false;        

        if(!form.cep) {
            erro.cep = "Informe o campo CEP";
            exibeErro = true;
        }                

        if(!form.logradouro) {
            erro.logradouro = "Informe o campo Logradouro";
            exibeErro = true;
        } 

        if(!form.endereco) {
            erro.endereco = "Informe o campo Endereço";
            exibeErro = true;
        }                
        
        if(!form.numero) {                
            erro.numero = "Informe o campo Número";
            exibeErro = true;
        }

        if(!form.bairro) {                
            erro.bairro = "Informe o campo Bairro";
            exibeErro = true;
        }

        if(!form.cidade) {                
            erro.cidade = "Informe o campo Cidade";
            exibeErro = true;
        }

        if(!form.uf) {                
            erro.uf = "Informe o campo UF";
            exibeErro = true;
        }
        
        if(exibeErro) {
            this.setState({ erroForm: erro });

            return;
        }

        this.setState({passo: 3});        
    }
    
    validaStep3() {
        this.limpaVariavelErro();

        let form = this.state.form;
        let erro = this.state.erroForm;
        let exibeErro = false;        

        if(!form.usuario) {
            erro.usuario = 'Informe o campo Usuário';
            exibeErro = true;
        }

        if(!form.email) {
            erro.email = 'Informe o campo E-mail';
            exibeErro = true;
        }

        if(!form.senha) {
            erro.senha = 'Informe o campo Senha';
            exibeErro = true;
        }

        if(exibeErro) {
            this.setState({ erroForm: erro });

            return false;
        }

        return true;
    }

    onSubmit() {                   
        if(!this.validaStep3())
            return ;

        this.setState({
            preload: true,
            btnFinalizar: 'AGUARDE...'
        });
        
        const form = new FormData(document.getElementById('form'));        

        ClienteService.cadastro(form).then(resposta => {              
            this.setState({preload: false});                                                            
            
            this.props.login(
                resposta.data.id, 
                this.state.form.email, 
                this.state.form.senha
            );
        }).catch(error => {                 
            this.setState({
                preload: false,
                btnFinalizar: 'FINALIZAR'
            });

            if(error.response === undefined || error.response.data === '') {
                this.setState({erro: this.P_ERRO_PADRAO()});
                return;
            }            

            this.setState({erro: error.response.data});
        });        
    }        
    
    show() {
        if(!this.props.visible)
            return ;        
        
        return (
            <Form onSubmit={() => this.onSubmit()} id="form">   
                <Preload show={this.state.preload} />

                <Alerta exibir={this.state.erro !== ''}
                        texto={this.state.erro} />                

                <input type="hidden" name="id" value={this.state.form.id}/>                

                {
                    this.state.passo === 1 &&
                    <Fragment>
                        <Fragment>
                            <div className="row">                            
                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}                                    
                                    classNameInput="background-transparent"  
                                    id="razao"
                                    nome="razao"
                                    defaultFoco={true}                                    
                                    value={this.state.form.razao}
                                    defaultValue={this.state.form.razao}
                                    erro={this.state.erroForm.razao}                                
                                    onChange={e => this.onChange(e)}>
                                    Razão Social
                                </Input>  

                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}
                                    classNameInput="background-transparent"  
                                    id="fantasia"
                                    nome="fantasia"                                    
                                    value={this.state.form.fantasia}
                                    defaultValue={this.state.form.fantasia}
                                    erro={this.state.erroForm.fantasia}                                
                                    onChange={e => this.onChange(e)}>
                                    Fantasia
                                </Input>                         
                            </div>                        

                            <div className="row"> 
                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}
                                    nome="cnpj"                                    
                                    classNameInput="background-transparent"  
                                    value={this.props.cnpj}
                                    defaultValue={this.props.cnpj}   
                                    erro={this.state.erroForm.cnpj}                             
                                    disabled={true}>
                                    Cnpj
                                </Input>

                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}   
                                    classNameInput="background-transparent"                                                                                            
                                    nome="inscr"                                    
                                    value={this.state.form.inscr}
                                    defaultValue={this.state.form.inscr}
                                    erro={this.state.erroForm.inscr}
                                    onChange={e => this.onChange(e)}>
                                    Inscrição Estadual
                                </Input>                        
                            </div>

                            <div className="row">                            
                                <InputPhone 
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}     
                                    classNameInput="background-transparent"
                                    nome="telefone"                                    
                                    value={this.state.form.telefone}
                                    erro={this.state.erroForm.telefone}
                                    onChange={e => this.onChange(e)}>
                                    Telefone
                                </InputPhone> 
                            </div>                        
                        </Fragment>

                        <div className="form-group mt-4 mb-0">
                            <button 
                                type="button"
                                className="btn btn-success btn-lg btn-block" 
                                onClick={e => this.validaStep1(e)}                                
                            >
                                PRÓXIMO PASSO (2 DE 3)

                                &nbsp;
                                &nbsp;

                                <i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </button>
                        </div>
                    </Fragment>
                }   

                {
                    this.state.passo === 2 &&
                    <Fragment>
                        <Fragment>
                            <div className="row">
                                <InputCep
                                    md={12}
                                    xs={12}
                                    sm={12}
                                    lg={12}
                                    classNameInput="background-transparent"  
                                    maxLength={9}
                                    defaultFoco={true} 
                                    type="text"
                                    id="cep"
                                    nome="cep"   
                                    proxFocoId="numero"                                 
                                    logradouros={this.state.logradouros}
                                    value={this.state.form.cep}
                                    defaultValue={this.state.form.cep}
                                    erro={this.state.erroForm.cep}
                                    onChange={e => this.onChange(e)}
                                    onBlur={e => this.onBlurCep(e)}
                                    onErro={e => this.onErroCep(e)}>
                                    CEP
                                </InputCep>                            
                            </div>

                            <div className="row">                              
                                <InputSelectLogradouro
                                    md={3}
                                    xs={3}
                                    sm={3}
                                    lg={3}                                                        
                                    classNameInput="background-transparent"  
                                    nome="logradouro"                                      
                                    value={this.state.form.logradouro}  
                                    erro={this.state.erroForm.logradouro}
                                    // defaultValue={this.state.form.logradouro}  
                                    onLoad={ e => this.onLoad(e) }                                
                                    onChange={ e => this.onChange(e) } />

                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}
                                    classNameInput="background-transparent"  
                                    nome="endereco"                                    
                                    value={this.state.form.endereco}
                                    defaultValue={this.state.form.endereco}
                                    erro={this.state.erroForm.endereco}
                                    onChange={e => this.onChange(e)}>
                                    Endereço
                                </Input>  

                                <Input
                                    md={3}
                                    xs={3}
                                    sm={3}
                                    lg={3}
                                    classNameInput="background-transparent"
                                    id="numero"  
                                    nome="numero"                                    
                                    value={this.state.form.numero}
                                    defaultValue={this.state.form.numero}
                                    erro={this.state.erroForm.numero}
                                    onChange={e => this.onChange(e)}>
                                    Nro
                                </Input>                                                      
                            </div>

                            <div className="row">                                                
                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}
                                    classNameInput="background-transparent"
                                    id="complemento"
                                    nome="complemento"                                    
                                    value={this.state.form.complemento}
                                    defaultValue={this.state.form.complemento}                                
                                    onChange={e => this.onChange(e)}>
                                    Complemento
                                </Input>                                                       
                            
                                <Input
                                    md={6}
                                    xs={6}
                                    sm={6}
                                    lg={6}
                                    classNameInput="background-transparent"  
                                    nome="bairro"                                    
                                    value={this.state.form.bairro}
                                    defaultValue={this.state.form.bairro}
                                    erro={this.state.erroForm.bairro}
                                    onChange={e => this.onChange(e)}>
                                    Bairro
                                </Input> 
                            </div>               

                            <div className="row">
                                <Input
                                    md={9}
                                    xs={9}
                                    sm={9}
                                    lg={9}
                                    classNameInput="background-transparent"  
                                    nome="cidade"                                    
                                    value={this.state.form.cidade}
                                    defaultValue={this.state.form.cidade}
                                    erro={this.state.erroForm.cidade}
                                    onChange={e => this.onChange(e)}>
                                    Cidade
                                </Input>                                                       

                                <InputSelectUF
                                    md={3}
                                    xs={3}
                                    sm={3}
                                    lg={3}                                                        
                                    nome="uf"                                    
                                    classNameInput="background-transparent"                                      
                                    value={this.state.form.uf}  
                                    erro={this.state.erroForm.uf}
                                    // defaultValue={this.state.form.uf}                                                            
                                    onChange={e => this.onChange(e)} />
                            </div>                    
                        </Fragment>

                        <div className="form-group mt-4 mb-0">
                            <button 
                                type="button"
                                className="btn btn-success btn-lg btn-block" 
                                onClick={e => this.validaStep2(e)}                                
                            >
                                PRÓXIMO PASSO (3 DE 3)

                                &nbsp;
                                &nbsp;

                                <i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </button>
                        </div>
                    </Fragment>
                }               

                {
                    this.state.passo === 3 &&
                    <Fragment>
                        <Fragment>
                            <input type="hidden" name="cnpj" value={this.state.form.cnpj}/>
                            <input type="hidden" name="razao" value={this.state.form.razao}/>
                            <input type="hidden" name="fantasia" value={this.state.form.fantasia}/>
                            <input type="hidden" name="inscr" value={this.state.form.inscr}/>
                            <input type="hidden" name="telefone" value={this.state.form.telefone}/>

                            <input type="hidden" name="cep" value={this.state.form.cep}/>
                            <input type="hidden" name="logradouro" value={this.state.form.logradouro}/>
                            <input type="hidden" name="endereco" value={this.state.form.endereco}/>
                            <input type="hidden" name="numero" value={this.state.form.numero}/>
                            <input type="hidden" name="complemento" value={this.state.form.complemento}/>
                            <input type="hidden" name="bairro" value={this.state.form.bairro}/>
                            <input type="hidden" name="cidade" value={this.state.form.cidade}/>
                            <input type="hidden" name="uf" value={this.state.form.uf}/>
                            
                            <input type="hidden" name="usuario" value={this.state.form.usuario}/>
                            <input type="hidden" name="email" value={this.state.form.email}/>
                            <input type="hidden" name="senha" value={this.state.form.senha}/>                                                   

                            <div className="row">
                                <Input
                                    md={12}
                                    xs={12}
                                    sm={12}
                                    lg={12}
                                    classNameInput="background-transparent"  
                                    nome="usuario"                                    
                                    value={this.state.form.usuario}
                                    defaultValue={this.state.form.usuario}
                                    erro={this.state.erroForm.usuario}
                                    onChange={e => this.onChange(e)}>
                                    Usuário
                                </Input>
                            </div>

                            <div className="row">
                                <Input
                                    md={12}
                                    xs={12}
                                    sm={12}
                                    lg={12}
                                    classNameInput="background-transparent"  
                                    nome="email"                                    
                                    value={this.state.form.email}
                                    defaultValue={this.state.form.email}
                                    erro={this.state.erroForm.email}
                                    onChange={e => this.onChange(e)}>
                                    E-mail
                                </Input>
                            </div>

                            <div className="row">
                                <InputPassword
                                    md={12}
                                    xs={12}
                                    sm={12}
                                    lg={12}
                                    classNameInput="background-transparent"  
                                    type="password"
                                    nome="senha"
                                    value={this.state.form.senha}
                                    defaultValue={this.state.form.senha}
                                    erro={this.state.erroForm.senha}
                                    onChange={e => this.onChange(e)}>
                                    Senha
                                </InputPassword>
                            </div>                        
                        </Fragment>

                        <div className="form-group mt-4 mb-0">
                            <button 
                                type="submit"
                                className="btn btn-success btn-lg btn-block"                                
                                disabled={this.state.btnFinalizar !== 'FINALIZAR'}
                            >
                                {this.state.btnFinalizar}
                            </button>
                        </div>
                    </Fragment>
                }                            
            </Form>
        )
    }    

    render () {
        return (        
            <Fragment>
                {this.show()}                    
            </Fragment>          
        )   
    }
}

export default Cadastro;